@switch (columnName) {
  @case ('exposedAt') {
    <span class="highlighted-text">
      {{ element.exposedAt | date }}
    </span>
    <span class="text-secondary">
      {{ element.exposedAt | date: timeFormat }}
    </span>
  }
  @case ('exposureDuration') {
    {{ element.exposureDuration?.name || '-' }}
  }
  @case ('exposureLocation') {
    {{ element.exposureLocation || '-' }}
    @if (placementKey) {
      <span class="text-secondary">· {{ placementKey | translate }}</span>
    }
  }
  @case ('safetyDataSheetConfirmed') {
    <mat-icon class="material-icons-round">
      {{ element.safetyDataSheetConfirmed ? 'check' : 'close' }}
    </mat-icon>
  }
  @case ('exposedPersons') {
    {{ peopleNames }}
  }
  @case ('exposedPositions') {
    {{ positionNames }}
  }
  @case ('quantityWithdrawn') {
    {{ amountDisplay || '-' }}
  }
  @case ('registeredBy') {
    {{ registeredByName }}
  }
  @case ('department') {
    {{ element.department?.name || '-' }}
  }
  @default {
    <app-default-cell [columnName]="columnName" [element]="element"></app-default-cell>
  }
}
